module.exports = __webpack_public_path__ + "static/media/sinterklass.029a148b.jpg";